import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { postRequest } from '../../helpers/apiHandler';

const DeleteUserRateModal = ({ show, handleClose, userData, getCreditData, setAlertState }) => {
  const { access_token } = useSelector((state) => state.auth.user);

  const handleConfirm = () => {
    postRequest(
      '/admin/user-rates-delete',
      {
        rate_id: userData.id,
      },
      access_token.token,
      (res) => {
        if (res.success) {
          setAlertState({
            show: true,
            variant: 'success',
            message: 'Success deleting data.',
          });
        } else {
          setAlertState({
            show: true,
            variant: 'danger',
            message: res.message,
          });
        }
        getCreditData();
      }
    );
    handleClose();
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Confirm Deletion</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Are you sure want to delete this data ? [{`${userData?.name} (${userData?.email})`}]
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="danger" onClick={handleConfirm}>
          Delete
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteUserRateModal;
